import { Colors, getPrice } from '@sigma-frontend-libs/commons'

import { buttonModes, components, popperPlacements, sizes } from '@/utils'

import squircle from '@/components/icon/squircle'
import UserWidget from '@/components/misc/UserWidget'
import tag from '@/components/tag'
import textOverflow from '@/components/text/overflow'

function renderIcon(h) {
  let iconSVG = 'user'
  let tooltip
  if (this.account.$verified) {
    iconSVG = 'user-verified'
    tooltip = this.getTranslate('commons.has.contract')
  }

  return h(
    squircle,
    {
      props: {
        iconSVG,
        iconSize: 32,
        size: sizes.medium,
        color: Colors.white,
        tooltip
      }
    }
  )
}
function renderUsername(h) {
  return h(
    textOverflow,
    {
      class: 'account-button__username',
      props: {
        value: this.account.username
      }
    }
  )
}
function renderBalance(h) {
  return h(
    tag,
    {
      props: {
        label: getPrice(this.balance),
        color: this.balanceColor,
        size: sizes.tiny,
        mode: buttonModes.filled
      }
    }
  )
}
function renderContent(h) {
  return h(
    'div',
    {
      class: 'account-button__content'
    },
    [
      renderUsername.call(this, h),
      renderBalance.call(this, h)
    ]
  )
}
function renderButton(h) {
  return h(
    'div',
    {
      class: 'account-button',
      slot: 'activator'
    },
    [
      renderIcon.call(this, h),
      renderContent.call(this, h)
    ]
  )
}
function renderWidget(h) {
  return h(
    UserWidget,
    {
      props: {
        overdraft: this.overdraft,
        rounded: this.viewport.breakpoint.mdUp
      },
      on: {
        show: event => {
          this.show = event
        }
      }
    }
  )
}

export default function(h) {
  return h(
    components.menu,
    {
      props: {
        value: this.show,
        closeOnContentClick: false,
        minWidth: 300,
        maxWidth: 400,
        placement: popperPlacements['bottom-end'],
        offsetDistance: 8,
        transparent: true
      },
      on: {
        input: event => {
          this.show = event
        }
      }
    },
    [
      renderButton.call(this, h),
      renderWidget.call(this, h)
    ]
  )
}
